"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _stitches = require("../../../stitches.config");

var _ImageOrLottie = _interopRequireDefault(require("../image-or-lottie/ImageOrLottie"));

var LoadingWrapper = (0, _stitches.styled)('div', {
  div: {
    color: '$textPrimary',
    fontSize: '30px',
    fontWeight: '$bold',
    marginBottom: '25px',
    textAlign: 'center',
    '@tablet': {
      marginbottom: '40px'
    }
  },
  variants: {
    isLoading: {
      false: {
        display: 'none'
      },
      true: {
        display: 'block'
      }
    }
  }
});

var Loading = function Loading(_ref) {
  var image = _ref.image,
      isLoading = _ref.isLoading,
      text = _ref.text;
  return /*#__PURE__*/_react.default.createElement(LoadingWrapper, {
    isLoading: isLoading
  }, /*#__PURE__*/_react.default.createElement("div", null, text), /*#__PURE__*/_react.default.createElement(_ImageOrLottie.default, Object.assign({}, image, {
    css: {
      marginLeft: 'auto',
      marginRight: 'auto',
      width: 'fit-content'
    }
  })));
};

Loading.defaultProps = {
  isLoading: false
};
var _default = Loading;
exports.default = _default;